import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import { BASE_URL } from "app/services/auth-services";
import { useGetExperiencewiseEmployeeForAllQuery, useGetExperiencewiseEmployeeQuery } from "app/services/RTK_Apis/dashbords/HomeDefaultApi";

function ThreeChart({ partnerName, companyId, businessUnit, isMobile }) {
  const theme = useTheme();

  const { data: expAllData } =
  useGetExperiencewiseEmployeeForAllQuery(undefined, {
    skip: businessUnit !== "All BU",
  });

const { data: expPartnerData } =
  useGetExperiencewiseEmployeeQuery(partnerName, {
    skip: businessUnit === "All BU" || !partnerName,
  });

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "donut",
        toolbar: { show: false },
        animations: { enabled: true },
      },
      labels: [],
      colors: [],
      dataLabels: {
        enabled: true,
        style: { fontSize: "11px", fontWeight: 500 },
      },
      legend: {
        position: "bottom",
        fontSize: "11px",
        labels: { colors: theme.palette.text.primary },
        itemMargin: { horizontal: 6, vertical: 3 },
      },
      plotOptions: {
        pie: {
          donut: {
            size: "65%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Total",
                fontSize: "12px",
                color: theme.palette.text.secondary,
                formatter: (w) =>
                  w.globals.seriesTotals.reduce((a, b) => a + b, 0),
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: { width: "100%" },
            legend: { position: "bottom", fontSize: "10px" },
            dataLabels: { style: { fontSize: "9px" } },
          },
        },
        {
          breakpoint: 480,
          options: {
            chart: { width: "100%" },
            legend: { position: "bottom", fontSize: "9px" },
          },
        },
      ],
      title: { text: "" },
    },
  });

  // 🎨 Distinct Colors
  const generateDistinctColors = (count) => {
    const baseColors = [
      "#4CAF50", "#2196F3", "#FF9800", "#9C27B0",
      "#E91E63", "#00BCD4", "#FF5722", "#8BC34A", "#3F51B5",
    ];
    return count <= baseColors.length
      ? baseColors.slice(0, count)
      : Array.from({ length: count }, (_, i) => `hsl(${(360 / count) * i}, 70%, 55%)`);
  };

useEffect(() => {

  const apiData =
    businessUnit === "All BU"
      ? expAllData
      : expPartnerData;

  if (!apiData) return;

  const labels = apiData.map(
    (item) => `${item.Exp} (${item.Count})`
  );

  const counts = apiData.map(
    (item) => Number(item.Count)
  );

  const colors = generateDistinctColors(counts.length);

  setChartData((prev) => ({
    ...prev,
    series: counts,
    options: {
      ...prev.options,
      labels,
      colors,
    },
  }));

}, [expAllData, expPartnerData, businessUnit]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: { xs: 1, sm: 1 },
        width: "100%",
        height: "100%",
      }}
    >
      <Typography
        variant={isMobile ? "subtitle1" : "h5"}
        fontWeight={600}
        sx={{ mb: 1, textAlign: "center" }}
      >
        Experience Wise
      </Typography>

      {chartData.series?.length > 0 ? (
        <Box
          sx={{
            width: "100%",
            maxWidth: isMobile ? 240 : 300,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="donut"
            width={isMobile ? 240 : 300}
            height={isMobile ? 240 : 260}
          />
        </Box>
      ) : (
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            textAlign: "center",
            mt: 2,
          }}
        >
          Nothing to preview
        </Typography>
      )}
    </Box>
  );
}

export default ThreeChart;
